module.exports = __webpack_public_path__ + "media/images/pictograms/pic3-1d94c324747e20d5e880a539626722d9.png";